class Pagination {
  /**
   * 
   * @param {*} pageSize 页大小
   * @param {*} pageTotal 一版页数量
   * @param {*} dataSource 数据源
   */
  constructor(pageSize, pageTotal, callback = null) {
    if (pageSize <= 0) {
      throw Error("分页大小必须为正整数")
    }

    this.pageSize = pageSize
    this.pageIndex = 1
    this.dataSource = []
    this.endIndex = 0
    this.pageTotal = pageTotal
    this.data = []
    this.pageList = [1]

    this.haveMoreData = false

    this.callback = callback
  }

  nextPage () {
    if (this.endIndex == this.pageIndex) {
      return
    }
    if ((this.pageIndex + 1) % this.pageTotal === 0 && this.callback && this.haveMoreData) {
      console.log("加载数据了")
      this.callback()
    }
    this.pageIndex++
    this.getPageData()
  }
  prevPage () {
    if (this.pageIndex === 0) {
      return
    }
    this.pageIndex--
    this.getPageData()
  }
  setPageIndex (index) {
    this.pageIndex = index
    this.getPageData()
    if (this.pageIndex % this.pageTotal === 0 && this.callback && this.haveMoreData) {
      console.log("加载数据了")
      this.callback()
    }
  }
  setPageSize (size) {
    this.pageSize = size
    this.getPageData()
  }
  jumpPage (pageIndex) {
    if (pageIndex > 0) {
      throw Error("页码必须为正整数")
    }
    this.pageIndex = pageIndex
    this.getPageData()
  }
  setDataSource (data) {
    if (!Array.isArray(data)) {
      throw Error("data必须为数组")
    }
    console.log(data)
    this.dataSource = this.dataSource.concat(data)
    this.endIndex = Math.ceil(this.dataSource.length / this.pageSize)
    this.jumpHaveMoreData()
    this.getPageData()
  }
  jumpHaveMoreData () {
    let haveMoreData = false
    if (this.dataSource.length !== 0 && this.dataSource.length % (this.pageSize * this.pageTotal) > 0) {
      haveMoreData = true
    }
    this.haveMoreData = haveMoreData
  }
  getPageData () {
    let startIndex = this.pageSize * (this.pageIndex - 1)
    let endIndex = this.pageSize * this.pageIndex
    if (endIndex > this.dataSource.length) {
      endIndex = this.dataSource.length
    }

    this.data = this.dataSource.slice(startIndex, endIndex)
    let pageList = []
    if (this.endIndex !== 0) {
      // debugger
      let multiple = Math.ceil(this.pageIndex / this.pageTotal) - 1
      // if (this.pageIndex + this.pageTotal > this.endIndex) {
      //   if (this.endIndex > this.pageTotal) {
      //     for (let i = this.endIndex; i > this.endIndex - this.pageTotal; i--) {
      //       pageList.push(i)
      //     }
      //     pageList.reverse()
      //   } else {
      //     for (let i = 1; i <= this.endIndex; i++) {
      //       pageList.push(i)
      //     }
      //   }
      // }
      // else {
      //   for (let i = 1; i <= this.pageTotal; i++) {
      //     pageList.push(this.pageTotal * multiple + i)
      //   }
      // }
      for (let i = 1; i <= this.pageTotal; i++) {
        if ((this.pageTotal * multiple + i) <= this.endIndex) {
          pageList.push(this.pageTotal * multiple + i)
        }
      }
    }
    else {
      pageList = [1]
    }

    this.pageList = pageList
  }
}

export default Pagination